import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { INSPECTION_PDF_REPORT_BASE } from '../inspection-pdf-report-base.token';
import { API_BASE } from '../api-base.token';
import { InspectionResponse } from '../inspections';
import { Location } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class InspectionPdfHttpService {
  constructor(
    @Inject(INSPECTION_PDF_REPORT_BASE)
    private readonly inspectionPdfReportBase: string,
    @Inject(API_BASE)
    private readonly apiBase: string,
    private readonly httpClient: HttpClient
  ) {}

  generateInspectionPdf(inspection: InspectionResponse) {
    return this.httpClient.post(this.inspectionPdfReportBase, inspection);
  }

  generateInspectionPdfV2(inspection: InspectionResponse) {
    const url = Location.joinWithSlash(this.apiBase, 'pdfengine/inspection');
    return this.httpClient.post(url, inspection);
  }
}
